module.exports = __webpack_public_path__ + "6b4fa6fd88cfc92e6377fb88162e9fc8.png";